
import { defineComponent } from "vue";
import WebsiteDetail from "../../../show/components/WebsiteDetailV2.vue";
import WebsiteDetailImage from "../../../show/components/WebsiteDetailImage.vue";
import 'vue-diff/dist/index.css';

export default defineComponent({
  components: {
    WebsiteDetail,
    WebsiteDetailImage
  },
  props: {
    website: {
      type: Object,
      required: true,
    },
    defaultDate: {
      type: String,
      default: "",
    },
  },
  emits: ["reload"],
  data() {
    return {
    };
  },
  watch: {
  },
  computed: {
  },
  methods: {
  },
});
